export default function Hero() {
  const stats = [
    { value: '128 部', label: '今日更新' },
    { value: '50,000+', label: '片库总量' },
    { value: '1080P+', label: '高清画质' },
  ];

  const handleAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[680px] md:min-h-[720px] flex items-center pt-16 overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(var(--primary-500)) 0%, transparent 50%), radial-gradient(circle at 80% 20%, oklch(var(--accent-500)) 0%, transparent 40%)',
        }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-5 whitespace-nowrap">
              每日更新 · 片源丰富 · 免费观看
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              星空电影网
              <br className="lg:hidden" />
              <span className="text-primary-600"> — 高清电影免费在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-700 font-medium mb-3">
              最新热门大片一站畅享，动作喜剧分类随心选
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl lg:max-w-none mb-8">
              星空电影网专注打造高品质免费观影体验，片库每日更新覆盖动作片、喜剧片、科幻片、悬疑片等全品类。无论是最新院线大片还是经典老片，高清画质流畅播放，分类清晰检索便捷，让每一场观影都成为享受。本周新增《封神第二部》《速度与激情10》等热门影片，快来探索你的专属片单。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">{s.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleAnchor('#ranking'); }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                立即观影
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleAnchor('#index'); }}
                className="inline-flex items-center gap-2 px-7 py-3 border border-secondary-300 text-foreground-700 font-medium text-sm rounded-md hover:bg-background-100 hover:border-secondary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-grid-line"></i>
                </span>
                查看分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-lg overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20amber%20lighting%2C%20plush%20deep%20red%20velvet%20seats%2C%20large%20silver%20screen%20with%20soft%20glow%2C%20elegant%20art%20deco%20architectural%20details%2C%20dramatic%20spotlight%20beams%20cutting%20through%20subtle%20atmospheric%20haze%2C%20rich%20dark%20wood%20paneling%2C%20luxurious%20cinema%20atmosphere%2C%20high%20end%20photography%2C%20warm%20golden%20and%20crimson%20tones%2C%20no%20people%20visible%2C%20elegant%20composition&width=960&height=1200&seq=hero-main-2026&orientation=portrait"
                alt="星空电影网 - 影院级观影体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}